// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";

export const getChangeEmailVerifiedToken = (
    state: ApplicationState,
): {
    idToken?: string;
    state?: string;
} => {
    const location = getLocation(state);
    const parsedQuery = parseQueryString<{ id_token: string; state?: string }>(location.hash || "");

    return {
        idToken: parsedQuery.id_token,
        state: parsedQuery.state,
    };
};
